module.exports = __webpack_public_path__ + "img/phonebottom.a2956651.png";